import axios from 'axios';
import type { ChoiceFilterOptions, FilterOptionResponseBody, GetDefinitionParams } from '../types/api/definition';
import { transformations } from '../utils/transformationLayer';
import { AXIOS_BASE_CONFIG } from './axiosConfig';
import type { ApiContext } from './types';
export function createDefinitionApi(ctx: ApiContext) {
  const BASE = `/v6/data-grid/${ctx.gridCode}`;
  return {
    getDefinition: (params?: GetDefinitionParams) => axios.get(`${BASE}/definition`, {
      ...AXIOS_BASE_CONFIG,
      params: {
        loadChoiceFilterOptions: params?.loadChoiceFilterOptions ?? true
      }
    }).then(response => transformations.transformDefinitionResponse(response.data)).catch(ctx.handleApiError),
    getColumnFilterOptions: (columnKey: string) => axios.get(`${BASE}/definition/column/${encodeURIComponent(columnKey)}/filter/options`, AXIOS_BASE_CONFIG).then(response => response.data as FilterOptionResponseBody[]).then<ChoiceFilterOptions>(response => response.map(option => ({
      label: option.label,
      value: option.key
    })))
  };
}